module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/diseases/arm_leg-95b95f797a72a3a3df1845eea2f60873.png";